if (!customElements.get("localization-form")) {
  customElements.define(
    "localization-form",
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia("(min-width: 750px)");
        this.header = document.querySelector(".header-wrapper");
        this.elements = {
          input: this.querySelector(
            'input[name="locale_code"], input[name="country_code"]'
          ),
          button: this.querySelector("button.localization-form__select"),
          panel: this.querySelector(".disclosure__list-wrapper"),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector(".country-selector__close-button"),
          resetButton: this.querySelector(".country-filter__reset-button"),
          searchIcon: this.querySelector(".country-filter__search-icon"),
          liveRegion: this.querySelector("#sr-country-search-results"),
        };
        this.addEventListener("keyup", this.onContainerKeyUp.bind(this));
        this.addEventListener("keydown", this.onContainerKeyDown.bind(this));
        this.addEventListener("focusout", this.closeSelector.bind(this));
        this.elements.button.addEventListener(
          "click",
          this.openSelector.bind(this)
        );

        const clickableDropdown = this.querySelector("#dropdown-v2");

        if (clickableDropdown && clickableDropdown?.dataset?.logic) {
          const changeSelectorLabel = (event) => {
            const selectButtonLabel = clickableDropdown.querySelector(
              "#select-button-label-dropdown-v2 span"
            );

            if (!selectButtonLabel) return;

            const label = event.currentTarget.dataset.label;
            const flagSrc = event.currentTarget.dataset.flagSrc;
            const flagAlt = event.currentTarget.dataset.flagAlt;

            selectButtonLabel.textContent = label;

            const selectButtonImage = clickableDropdown.querySelector(
              "#select-button-label-dropdown-v2 img"
            );

            if (flagSrc && flagAlt && selectButtonImage) {
              selectButtonImage.src = flagSrc;
              selectButtonImage.alt = flagAlt;
            }
          };

          switch (clickableDropdown.dataset.logic) {
            case "currency-selector": {
              // Initial load
              const paymentCurrency = localStorage.getItem("paymentCurrency");

              if (paymentCurrency) {
                const paymentCurrencyData = JSON.parse(paymentCurrency);
                clickableDropdown.querySelector(
                  "#select-button-label-dropdown-v2 span"
                ).textContent = paymentCurrencyData.label;
              }

              // On click change
              clickableDropdown.querySelectorAll("a").forEach((item) => {
                item.addEventListener("click", (event) => {
                  event.preventDefault();

                  let currentPaymentCurrency =
                    localStorage.getItem("paymentCurrency");

                  currentPaymentCurrency = JSON.parse(currentPaymentCurrency);

                  if (
                    currentPaymentCurrency?.value !==
                    event.currentTarget.dataset.value
                  ) {
                    localStorage.setItem(
                      "paymentCurrency",
                      JSON.stringify({
                        value: event.currentTarget.dataset.value
                          .replace(/\n/g, "")
                          .trim(),
                        label: event.currentTarget.dataset.label
                          .replace(/\n/g, "")
                          .trim(),
                      })
                    );
                    window.dispatchEvent(new Event("paymentCurrencyChanged"));

                    changeSelectorLabel(event);
                  }

                  this.hidePanel();
                });
              });
              break;
            }
            case "region-selector": {
              // On click change
              clickableDropdown.querySelectorAll("a").forEach((item) => {
                item.addEventListener("click", (event) => {
                  event.preventDefault();

                  changeSelectorLabel(event);

                  const input = this.querySelector(
                    "[name='denomination_region']"
                  );

                  if (!input) return;

                  input.value = event.currentTarget.dataset.value;

                  // Trigger change event
                  const changeEvent = new Event("change", { bubbles: true });
                  input.dispatchEvent(changeEvent);

                  this.hidePanel();
                });
              });
              break;
            }
            case "modal-localization-country-selector": {
              clickableDropdown.querySelectorAll("a").forEach((item) => {
                item.addEventListener("click", (event) => {
                  event.preventDefault();

                  changeSelectorLabel(event);

                  const input = this.querySelector("[name='country_code']");

                  if (!input) return;

                  input.value = event.currentTarget.dataset.value;

                  // Trigger change event
                  const changeEvent = new Event("change", { bubbles: true });
                  input.dispatchEvent(changeEvent);
                  this.hidePanel();
                });
              });
              break;
            }
            case "modal-localization-language-selector": {
              clickableDropdown.querySelectorAll("a").forEach((item) => {
                item.addEventListener("click", (event) => {
                  event.preventDefault();

                  changeSelectorLabel(event);

                  const input = this.querySelector("[name='locale_code']");

                  if (!input) return;

                  input.value = event.currentTarget.dataset.value;

                  // Trigger change event
                  const changeEvent = new Event("change", { bubbles: true });
                  input.dispatchEvent(changeEvent);
                  this.hidePanel();
                });
              });
              break;
            }
            default: {
              // If dont see a trigger Need to setup dropdown logic when logic is specified
              // IMPORTANT: DO NOT RETURN HERE.
              break;
            }
          }
        }

        if (this.elements.search) {
          this.elements.search.addEventListener(
            "keyup",
            this.filterCountries.bind(this)
          );
          this.elements.search.addEventListener(
            "focus",
            this.onSearchFocus.bind(this)
          );
          this.elements.search.addEventListener(
            "blur",
            this.onSearchBlur.bind(this)
          );
          this.elements.search.addEventListener(
            "keydown",
            this.onSearchKeyDown.bind(this)
          );
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener(
            "click",
            this.hidePanel.bind(this)
          );
        }
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener(
            "click",
            this.resetFilter.bind(this)
          );
          this.elements.resetButton.addEventListener("mousedown", (event) =>
            event.preventDefault()
          );
        }

        this.querySelectorAll("a").forEach((item) =>
          item.addEventListener("click", this.onItemClick.bind(this))
        );
      }

      hidePanel() {
        this.elements.button.setAttribute("aria-expanded", "false");
        this.elements.panel.setAttribute("hidden", true);
        if (this.elements.search) {
          this.elements.search.value = "";
          this.filterCountries();
          this.elements.search.setAttribute("aria-activedescendant", "");
        }
        document.body.classList.remove("overflow-hidden-mobile");
        document
          .querySelector(".menu-drawer")
          .classList.remove("country-selector-open");
        this.header.preventHide = false;
        const backdrop = document.getElementById("localization-modal-backdrop");
        if (backdrop) {
          setTimeout(() => {
            backdrop.style["pointer-events"] = "auto";
          }, 300);
        }
      }

      localDomainRedirect(localDomainMarket) {
        const newDomain = localDomainMarket.local_domain_redirect;
        const currentUrl = new URL(window.location.href);
        const newDomainUrl = new URL(newDomain);

        const newUrl = new URL(currentUrl);
        newUrl.protocol = newDomainUrl.protocol;
        newUrl.host = newDomainUrl.host;

        let newPathname = "/";

        if (currentUrl.pathname.length > 3) {
          const langSuffixEndIndex = currentUrl.pathname.indexOf("/", 1);

          if (langSuffixEndIndex !== -1) {
            const languageSuffix = currentUrl.pathname.substring(
              1,
              langSuffixEndIndex
            );

            if (languageSuffix.length === 2) {
              newPathname = currentUrl.pathname.substring(langSuffixEndIndex);
            } else {
              newPathname = currentUrl.pathname;
            }
          } else {
            newPathname = currentUrl.pathname;
          }
        }

        newUrl.pathname = newPathname;

        if (newUrl.port) {
          newUrl.port = "";
        }

        window.location.href = newUrl.toString();
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll("a")).filter(
          (item) => !item.parentElement.classList.contains("hidden")
        );
        let focusedItemIndex = focusableItems.findIndex(
          (item) => item === document.activeElement
        );
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case "ARROWUP":
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0
                ? focusableItems[focusedItemIndex - 1]
                : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case "ARROWDOWN":
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1
                ? focusableItems[focusedItemIndex + 1]
                : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex(
            (item) => item === document.activeElement
          );
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute(
              "aria-activedescendant",
              focusableItems[focusedItemIndex].id
            );
          } else {
            this.elements.search.setAttribute("aria-activedescendant", "");
          }
        });
      }

      onContainerKeyUp(event) {
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case "ESCAPE":
            if (this.elements.button.getAttribute("aria-expanded") == "false")
              return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case "SPACE":
            if (this.elements.button.getAttribute("aria-expanded") == "true")
              return;
            this.openSelector();
            break;
        }
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector("form");

        if (!this.elements.input) return;
        this.elements.input.value = event.currentTarget.dataset.value;

        const clickableDropdown = this.querySelector("#dropdown-v2");

        if (
          clickableDropdown?.dataset?.logic === "local-domain-market-selector"
        ) {
          const localDomainMarket = localDomainMarkets?.find(
            (market) => market.iso_code === this.elements.input.value
          );

          if (localDomainMarket && localDomainMarket.local_domain_redirect) {
            this.localDomainRedirect(localDomainMarket);
            return;
          }
        }

        if (form) {
          form.submit();
        }
      }

      openSelector() {
        const backdrop = document.getElementById("localization-modal-backdrop");
        if (backdrop) {
          backdrop.style["pointer-events"] = "none";
        }

        this.elements.button.focus();
        this.elements.panel.toggleAttribute("hidden");
        this.elements.button.setAttribute(
          "aria-expanded",
          (
            this.elements.button.getAttribute("aria-expanded") === "false"
          ).toString()
        );
        if (!document.body.classList.contains("overflow-hidden-tablet")) {
          document.body.classList.add("overflow-hidden-mobile");
        }
        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        }
        if (this.hasAttribute("data-prevent-hide")) {
          this.header.preventHide = true;
        }
        document
          .querySelector(".menu-drawer")
          .classList.add("country-selector-open");
      }

      closeSelector(event) {
        if (
          event.target.classList.contains("country-selector__overlay") ||
          !this.contains(event.target) ||
          !this.contains(event.relatedTarget)
        ) {
          event.stopPropagation();

          this.hidePanel();
        }
      }

      normalizeString(str) {
        return str
          .normalize("NFD")
          .replace(/\p{Diacritic}/gu, "")
          .toLowerCase();
      }

      filterCountries() {
        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector(".popular-countries");
        const allCountries = this.querySelectorAll("a");
        let visibleCountries = allCountries.length;

        this.elements.resetButton.classList.toggle("hidden", !searchValue);

        if (popularCountries) {
          popularCountries.classList.toggle("hidden", searchValue);
        }

        allCountries.forEach((item) => {
          const countryName = this.normalizeString(
            item.querySelector(".country").textContent
          );
          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove("hidden");
            visibleCountries++;
          } else {
            item.parentElement.classList.add("hidden");
            visibleCountries--;
          }
        });

        if (this.elements.liveRegion) {
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.countrySelectorSearchCount.replace(
              "[count]",
              visibleCountries
            );
        }

        this.querySelector(".country-selector").scrollTop = 0;
        this.querySelector(".country-selector__list").scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = "";
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        this.elements.searchIcon.classList.add(
          "country-filter__search-icon--hidden"
        );
      }

      onSearchBlur() {
        if (!this.elements.search.value) {
          this.elements.searchIcon.classList.remove(
            "country-filter__search-icon--hidden"
          );
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === "ENTER") {
          event.preventDefault();
        }
      }
    }
  );
}
